/// <reference path="../../_ext/editors/ItemGridEditor.ts" />


namespace TabAurous.ECommerce {
    import fld = ECommSalesItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.registerEditor()
    export class ECommSalesItemsEditor extends _Ext.ItemGridEditor<ECommSalesItemsRow> {
        protected getColumnsKey() { return "ECommerce.ECommSalesItems"; }
        protected getDialogType() { return ECommSalesItemsDialog; }
        protected getLocalTextPrefix() { return ECommSalesItemsRow.localTextPrefix; }
        protected

        protected form: ECommSalesItemsForm;
        private pendingChanges: Q.Dictionary<any> = {};

        protected get_ExtGridOptions() {
            let opt = super.get_ExtGridOptions();
            opt.AutoColumnSize = true;
            opt.ShowDeleteInlineButtun = false;
            opt.ShowRowNumberColumn = true;
            return opt;
        }

        // #region Variables
        public salespersonId = 0;
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;

        public TransDate: Date;
        public ExchangeRate: number;
        public DeptId: number;
        public TotalItems: number;
        public ProductTypeId: number;
        statement: string;
        //validate pieces and weight on new creation
        public pieces = [];
        public weight = [];
        public itemids = [];
        public isUpdate: number;
        public canUpdate: number;
        // #endregion


        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: true });
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as ECommSalesDialog).CalculateAmountandTax(this.view.getItems(), this.view.getItems().length);
                }
            })
        }

        setMasterValues() {
            this.RateListId = (this.parentDialog as ECommSalesDialog).RateListId;
            this.LaborListId = (this.parentDialog as ECommSalesDialog).LaborMarkup;
            this.StoneMarkup = (this.parentDialog as ECommSalesDialog).StoneMarkup;
            this.StoneDiscount = (this.parentDialog as ECommSalesDialog).StoneDiscount;
            this.LaborMarkup = (this.parentDialog as ECommSalesDialog).LaborMarkup;
            this.LaborDiscount = (this.parentDialog as ECommSalesDialog).LaborDiscount;
            this.ExchangeRate = (this.parentDialog as ECommSalesDialog).ExchangeRate;
            this.TransDate = (this.parentDialog as ECommSalesDialog).form.TransDate.valueAsDate;
            this.PartyId = parseInt((this.parentDialog as ECommSalesDialog).form.POSCustomerId.value);
            this.salespersonId = parseInt((this.parentDialog as ECommSalesDialog).form.EmployeeId.value);
        }  
        private getItem(SKU: string) {
            var StockID = [];
            Stock.StockItemService.GetStockTransactions({
                SKU: SKU

            },
                response => StockID = response.Entities,
                {
                    async: false
                });

            var Quantity = 0;
            if (StockID.length > 0) {
                for (var x of StockID) {
                    Quantity += x.Pieces;
                };

                if (Quantity > 0) {
                    var Item = StockID.pop();
                }
            }

        }


        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();

            var num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
            var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this);
            var str = ctx => ColumnFormatter.stringInputFormatter(ctx, this);
            Q.first(columns, x => x.field === fld.Discount).format = num;
            Q.first(columns, x => x.field === fld.DiscountPer).format = num;
            
            Q.first(columns, x => x.field === fld.Pieces).format = int;
            Q.first(columns, x => x.field === fld.Weight).format = num;
            var Employee = Q.first(columns, x => x.field === fld.EmployeeId);
            Employee.referencedFields = [fld.EmployeeId];
            Employee.format = ctx => ColumnFormatter.selectFormatter(ctx, fld.EmployeeId, Master.EmployeeMasterRow.getLookup(), this);

            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });
            this.view.refresh();
            return columns;
        }

        // #endregion

        public getTotalRows() {
            this.TotalItems = this.view.getItems().length;

            return this.TotalItems;
        }

        //#region Inline Editor
        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject,) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.Pieces) {
                value = Q.parseInteger(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            } else if (field === fld.Weight || field === fld.Discount) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }

            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0 && item.ItemTypeId == 101) {

                if (item.CalcOnId == 3) {
                    item.GrossAmount = item.NetAmount * value;
                    item.Weight = (item.Weight / item.Pieces) * value;
                    item.DiamondPieces = (item.DiamondPieces / item.Pieces) * value;
                    item.DiamondWeight = (item.DiamondWeight / item.Pieces) * value;
                    item.DiamondAmount = (item.DiamondAmount / item.Pieces) * value;
                    item.StonePieces = (item.StonePieces / item.Pieces) * value;
                    item.StoneWeight = (item.StoneWeight / item.Pieces) * value;
                    item.StoneAmount = (item.StoneAmount / item.Pieces) * value;
                    item.OtherPieces = (item.OtherPieces / item.Pieces) * value;
                    item.OtherWeight = (item.OtherWeight / item.Pieces) * value;
                    item.OtherAmount = (item.OtherAmount / item.Pieces) * value;
                    item.NetWeight = (item.NetWeight / item.Pieces) * value;
                    item.BOMDetails.forEach(function (x) {
                        var Pieces = (x.Pieces / item.Pieces) * value;
                        var Weight = (x.Weight / item.Pieces) * value;
                        if (x.CalcOnId == 3) {
                            x.BomAmount = x.BomRate * Pieces;
                        }
                        else {
                            if (x.ItemTypeId == 104)
                                x.BomAmount = x.BomRate * Weight * x.Purity;
                            else
                                x.BomAmount = x.BomRate * Weight;
                        }
                        x.Pieces = Pieces;
                        x.Weight = Weight;
                    })
                    if (item.WstPer != null) {
                        item.WstWt = item.NetWeight * (item.WstPer / 100);
                    }
                }
                item[field] = value;
            }
            // **** Allow to Set Pcs to Zero for RM ****
            if (field === fld.Pieces && item.ItemTypeId != 101) {
                if (item.CalcOnId == 3) {
                    var labr = item.UnitLabour || 0;
                    var Net = ((item.UnitRate + labr) / item.Pieces) * value;
                    item.NetAmount = Net;
                    var Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount
                    item.GrossAmount = Net - Discount;
                    item.Weight = item.Pieces < value ? item.Weight * value : (item.Weight / item.Pieces) * value;
                    item.NetWeight = item.Pieces < value ? item.NetWeight * value : (item.NetWeight / item.Pieces) * value;
                    if (item.WstPer != null) {
                        item.WstWt = item.NetWeight * (item.WstPer / 100);
                    }
                    item[field] = value;
                }
                else {
                    item[field] = value;
                }

            }

            // **** Allow to Set Weight for RM ****
            if (field === fld.Weight && item.ItemTypeId != 101) {
                if (item.CalcOnId != 3) {
                    var labr = item.UnitLabour || 0;
                    var Net = ((item.UnitRate + labr) / item.Weight) * value;
                    item.NetAmount = Net;
                    var Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount
                    item.GrossAmount = Net - Discount;
                    item.NetWeight = value;
                    if (item.WstPer != null) {
                        item.WstWt = value * (item.WstPer / 100);
                    }
                    item[field] = value;
                }
                else {
                    item[field] = value;
                }

            }

            // **** Calculate Amount based on UnitRate and Weight or Pieces
            if (field === fld.UnitRate && item.ItemTypeId != 101) {
                if (item.CalcOnId != 3) {
                    var labr = item.UnitLabour || 0;
                    var Net = (item.Weight * value) + labr;
                    item.NetAmount = Net;
                    var Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount;
                    item.GrossAmount = Net - Discount;

                }


                if (item.CalcOnId == 3) {
                    var labr = item.UnitLabour || 0;
                    var Net = (item.Pieces * value) + labr;
                    item.NetAmount = Net;
                    var Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount;
                    item.GrossAmount = Net - Discount;

                }

                item[field] = value;
            }

            // *** Calculate Wastage ***
            if (field === fld.WstPer && value >= 0) {
                item.WstWt = item.NetWeight * (value / 100);
                item[field] = value;
            }

            // *** Calculate Discount ***
            if (field === fld.Discount && value >= 0) {

                Q.reloadLookup(Administration.ItemDiscountDetailsRow.lookupKey);
                var DiscountPer = (value / item.NetAmount) * 100;
                var AllowedDiscount = Q.tryFirst(Administration.ItemDiscountDetailsRow.getLookup().items, x => x.Id == 2 && x.ProductTypeId == item.ProductTypeId).MaxDiscount;
                if (AllowedDiscount != undefined && DiscountPer <= AllowedDiscount) {
                    item.GrossAmount = item.NetAmount - value;
                    item.DiscountPer = (value / item.NetAmount) * 100;
                    item[field] = value;
                }
                else {
                    Q.warning(q.text('Message.Discount.NotAllowed', 'You are not Authorized to give that much discount'))
                }

            }

            // *** Calculate Discount % ***
            if (field === fld.DiscountPer && value >= 0) {

                Q.reloadLookup(Administration.ItemDiscountDetailsRow.lookupKey);

                var AllowedDiscount = Q.tryFirst(Administration.ItemDiscountDetailsRow.getLookup().items, x => x.Id == 2 && x.ProductTypeId == item.ProductTypeId).MaxDiscount;
                if (AllowedDiscount != undefined && value <= AllowedDiscount) {
                    var Discount = (item.NetAmount * value) / 100
                    item.GrossAmount = item.NetAmount - Discount;
                    item.Discount = Discount;
                    item[field] = value;
                }
                else {
                    //Q.warning(q.text('Message.Discount.NotAllowed', 'You are not Authorized to give that much discount'));
                    q.Authorize('Not Allowed', 'You are not Authorized')
                }

            }

            // *** Set Department ***
            if (field === fld.DepartmentId && value > 0) {
                item[field] = value;

            }

            this.view.updateItem(id, item);
            this.view.refresh();

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }


        // #endregion


        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();

            // *** Add Select Button to Grid Editor ***
            buttons.push({
                title: "Select Products",
                cssClass: "add-button",
                hotkey: "Alt + K",
                onClick: () => {


                    var grid = Common.POSStockSelectGrid;
                    this.setMasterValues();

                    // **** Validate Party before Item Selection ****
                    if (isNaN(this.PartyId)) {
                        Q.notifyWarning("Please select Customer to proceed");
                        return;
                    } else if (this.salespersonId == 0 || this.salespersonId == null) {
                        Q.notifyWarning("Please select Sales Person to proceed");
                        return;
                    }

                    else {

                        var filters: _Ext.SelectGridFilters = {

                        }
                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true,
                            preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                        });
                    }

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.Line_No == t.Line_No) });
                        let self = this;
                        var ItemDetails = ItemGridHelper.SetRetailItemGrid(selectedItems2, this.TransDate, this.PartyId, this.ExchangeRate, this.RateListId, this.LaborListId, this.LaborMarkup);
                        ItemDetails.forEach(function (Item: ECommSalesItemsRow) {
                            Item.EmployeeId = Q.parseInteger((self.parentDialog as ECommSalesDialog).form.EmployeeId.value);
                        });

                        this.setData(ItemDetails);
                    }
                    // #endregion

                    pickerDialog.dialogOpen();
                }
            });
            buttons.push({
                title: "Select Orders",
                cssClass: "add-button",
                hotkey: "alt+k",
                onClick: () => {

                    var grid = ECommerce.ECommOrderItemsSelectGrid;
                    this.setMasterValues();
                    // **** Validate Party before Item Selection ****
                    if (isNaN(this.PartyId)) {
                        Q.notifyWarning("Please select Customer to proceed");
                        return;
                    }

                    else {
                        var filters: _Ext.SelectGridFilters = {
                            CustomerId: this.PartyId,
                            InStock:true
                        } 
                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true,
                            preSelectedKeys: this.value.map(k => k.ProductId), GridFilters:filters
                        });
                    }

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });

                        var ItemDetails = ItemGridHelper.SetRetailItemGrid(selectedItems2, new Date(), this.PartyId, this.ExchangeRate, this.RateListId, this.LaborListId, this.LaborMarkup);
                        this.setData(ItemDetails);
                    }
                    // #endregion

                    pickerDialog.dialogOpen();
                }
            });
    
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            return buttons;
        }


        // #endregion

        // #region Set Data

        setData(ItemDetails: any[]) {
            if (this.view.getItems().length > 0) {
                this.TotalItems = ItemDetails.length + this.view.getItems().length;
            }
            else {
                this.TotalItems = ItemDetails.length;
            }
            for (let Itemdetail of ItemDetails) {
                Itemdetail.IsRepairProcess = false;
                Itemdetail[this.getIdProperty()] = "`" + this.nextId++;
                this.view.addItem(Itemdetail);
            }
        }

        // #endregion

    }
}